import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevrons-up-right', 'ChevronsUpRight', [["path",{"d":"M9 7h8v8"}],["path",{"d":"M5 11h8v8"}]]);